import { Container, Row, Col, Button } from "react-bootstrap";
import BillingHeader from "../../components/billingPayment/BillingHeader";
import BillingStats from "../../components/billingPayment/BillingStats";
import BillingOverviewChart from "../../components/billingPayment/BillingOverviewChart";
import RecentInvoices from "../../components/billingPayment/RecentInvoices";
import ChargesChart from "../../components/billingPayment/ChargesChart";
import PaymentMethods from "../../components/billingPayment/PaymentMethods";
import AutoPayCard from "../../components/billingPayment/AutoPayCard";
import TransactionsTable from "../../components/billingPayment/TransactionsTable";
import { useCallback, useEffect, useState } from "react";
import { Loader } from "../../components/common/Loader";
import { errorAlert } from "../../components/common/Alert";
import { getBillingAnalyticsApi, getBillingTransactionsApi, getBillingInvoicesApi, getBillingOverviewApi, getBillingCategoryAnalyticsApi } from "../../services/Networkcall";
import moment from "moment";
import DatePicker from "react-datepicker";
import { GrPowerReset } from "react-icons/gr";

export default function Payment() {
    const [analyticsData, setAnalyticsData] = useState();
    const [loading, setLoading] = useState(false);
    const [transactionData, setTransactionData] = useState();
    const [pagination, setPagination] = useState({ page: 1, limit: 10, totalRecords: 0, totalPages: 0 });
    const [filter, setFilter] = useState({ startDate: null, endDate: null })

    const fetchAnalyticsData = async () => {
        setLoading(true);
        try {
            const res = await getBillingAnalyticsApi();
            if (res?.success) {
                setAnalyticsData(res?.data || {});
            } else {
                errorAlert({ message: res?.message || "Failed to fetch billing report" });
            }
        } catch (err) {
            errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to fetch billing report" });
        }
        setLoading(false);
    };

    const fetchTransactionsData = async () => {
        setLoading(true);
        try {
            const payload = {
                page: pagination.page,
                limit: pagination.limit,
                startDate: filter?.startDate ? moment(filter.startDate).startOf('day').utc().format() : '',
                endDate: filter?.endDate ? moment(filter.endDate).endOf('day').utc().format() : '',

            }
            const res = await getBillingTransactionsApi(payload);
            if (res?.success) {
                setTransactionData(res?.data || []);
                setPagination(prev => ({ ...prev, totalRecords: res?.totalRecords, totalPages: res?.totalPages }));
            } else {
                errorAlert({ message: res?.message || "Failed to fetch transactions report" });
            }
        } catch (err) {
            errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to fetch transactions report" });
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchAnalyticsData();
    }, []);

    useEffect(() => {
        fetchTransactionsData();
    }, [pagination?.page, filter.startDate && filter.endDate]);


    const pageHandler = useCallback((page) => {
        setPagination(prev => ({ ...prev, page }));
    }, []);

    const handleReset = () => {
        setFilter({ startDate: null, endDate: null });
    }


    return (
        <Container fluid className="billing-page vh-100 overflow-scroll">
            <Loader show={loading} />

            <div className="billing-header">
                <div>
                    <h3>Payments </h3>
                    <p>Overview of your payments, transaction history, and financial activity.</p>
                </div>
            </div>

            {/* <BillingStats analytics={analyticsData} /> */}


            <Row className="py-3 px-2 bg-light">

                {/* SEARCH   */}
                <Col xl={4} lg={6} md={12}>

                    <div className="d-flex gap-3 align-items-end">


                        {/* 📅 Date Range     */}
                        <div className="date-picker-wrapper flex-column d-flex">
                            <label className="mb-2">Select Range  </label>

                            <DatePicker
                                placeholderText="dd/mm/yyyy - dd/mm/yyyy"
                                selectsRange
                                startDate={filter?.startDate}
                                endDate={filter?.endDate}
                                onChange={(update) => {
                                    setFilter({
                                        startDate: update[0],
                                        endDate: update[1],
                                    });
                                }}
                                className="form-control cursor-pointer"
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                        {(filter.startDate || filter?.endDate) && <Button variant="transparent" onClick={handleReset} className="border rounded"><GrPowerReset className="me-1" />Reset</Button>}
                    </div>
                </Col>

            </Row>

            <Row >
                <Col >
                    <TransactionsTable transactions={transactionData} pagination={pagination} pageHandler={pageHandler} />
                </Col>
            </Row>

        </Container>
    );
}